import React, { KeyboardEvent, ChangeEvent } from "react";
import { Box, Button, FormControl, InputLabel, TextField} from "@mui/material";
import { useTranslation } from "react-i18next";
import SearchIcon from "@mui/icons-material/Search";

interface ISearchProps {
  searchQuery: string;
  onSearchQueryChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onSearchKeyUp: (event: KeyboardEvent<HTMLDivElement>) => void;
  refreshSearch: () => void;
  searchRef: any;
}

export function Search(searchProps: ISearchProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <Box display="flex" justifyContent="flex-end"  sx={{padding: "8px 0", margin: "8px 0 0 auto"}}>
      <FormControl variant="standard">
        {searchProps.searchQuery.length === 0 && <InputLabel htmlFor="logLevel-select">{t("search")}</InputLabel>}
        <TextField
          margin="normal"
          id="url"
          name="url"
          variant="standard"
          inputRef={searchProps.searchRef}
          sx={{width:'300px',paddingTop:"2px"}}
          value={searchProps.searchQuery}
          onChange={searchProps.onSearchQueryChange}
          onKeyUp={searchProps.onSearchKeyUp}
        />
      </FormControl>
      <Button
        variant="contained"
        color="primary"
        sx={{margin:"1rem"}}
        data-cy="search-button"
        onClick={searchProps.refreshSearch}>
        <SearchIcon fontSize="large" />
      </Button>
    </Box>
  );
}
